import { Component, HostBinding, Input } from '@angular/core';

import {
	AttributeString,
	attributeStringBooleanParser,
	attributeStringEnumParser,
} from '~app-ui-new/utils';

export enum BaseButtonSize {
	SMALL = 'SMALL',
	MEDIUM = 'MEDIUM',
	LARGE = 'LARGE',
}

export enum BaseButtonIconPosition {
	LEFT = 'LEFT',
	RIGHT = 'RIGHT',
}

@Component({
	template: '',
	host: {
		class: 'fl fl-ai-c fl-jc-c border-box br-1',
	},
})
export abstract class UiNewButtonBase {
	// CORE

	protected abstract extraClassesKeys: Array<keyof this>;
	protected baseClassesKeys: Array<keyof UiNewButtonBase> = ['size', 'smallIconPosition'];

	@HostBinding('class')
	public get extraClasses(): string {
		const keys = [...this.baseClassesKeys, ...this.extraClassesKeys];
		return keys
			.map((key) => {
				const value = this[key] as string;
				if (value) {
					return `${key as string}-${value}`;
				}
				return '';
			})
			.filter((item) => !!item)
			.join(' ');
	}

	// ACTIVE

	private _active = false;

	@HostBinding('class.active')
	@Input('active')
	public set active(active: AttributeString<boolean>) {
		this._active = attributeStringBooleanParser(active, this._active);
	}

	public get active(): boolean {
		return this._active;
	}

	// DISABLED - If the button can be clicked

	private _disabled = false;

	@HostBinding('class.disabled')
	@Input('disabled')
	public set disabled(disabled: AttributeString<boolean>) {
		this._disabled = attributeStringBooleanParser(disabled, this._disabled);
	}

	public get disabled(): boolean {
		return this._disabled;
	}

	@HostBinding('class.enabled')
	public get enabled(): boolean {
		return !this.disabled;
	}

	// SIZE

	private _size = BaseButtonSize.MEDIUM;

	@HostBinding('class.size')
	@Input('size')
	public set size(size: AttributeString<BaseButtonSize>) {
		this._size =
			attributeStringEnumParser(size, BaseButtonSize, BaseButtonSize.MEDIUM) ??
			BaseButtonSize.MEDIUM;
	}

	public get size(): BaseButtonSize {
		return this._size;
	}

	// SMALL ICON POSITION

	private _smallIconPosition: BaseButtonIconPosition | null = null;

	@Input()
	public set smallIconPosition(smallIconPosition: AttributeString<BaseButtonIconPosition>) {
		this._smallIconPosition = attributeStringEnumParser(
			smallIconPosition,
			BaseButtonIconPosition,
			null
		);
	}

	public get smallIconPosition() {
		return this._smallIconPosition as AttributeString<BaseButtonIconPosition>;
	}
}
